var SameMonthDateValidator = (function () {
    function SameMonthDateValidator() {
    }
    SameMonthDateValidator.prototype.ResolvedDateIsInSameMonth = function (yyyy, mm, dd) {
        var year = parseInt(yyyy);
        var month = parseInt(mm) - 1;
        var day = parseInt(dd);
        var date = new Date(year, month, day);
        if (date.getFullYear() == year &&
            date.getMonth() == month &&
            date.getDate() == day) {
            return true;
        }
        return false;
    };
    return SameMonthDateValidator;
}());
export { SameMonthDateValidator };
//# sourceMappingURL=SameMonthDateValidator.js.map